export default {
  "group0": "Applications & Services",
  "group1": "Account & Security",
  "group2": "Jobs & Automation",
  "group3": "Support & Collaboration",
  "group4": "Digest & Noise Controls",
  "group5": "Fleet Visibility",
  "group6": "General",
  "group7": "Applications",

  "Dashboard": "Dashboard",
  "Profile": "Profile",
  "Settings": "Settings",
  "System": "System",
  "Software": "Software",
  "Support": "Support",
  "Notifications": "Notifications",
  "NotificationCenter": "Notification Center",
  "GeneralSettings": "General Settings",
  "EmailSettings": "Email Settings",
  "NotificationSettings": "Notification Settings",
  "SessionSettings": "Session Settings",
  "SecuritySettings": "Security Settings",
  "RegistrationSettings": "Registration Settings",
  "SystemDashboard": "System Dashboard",
  "StreamingDashboard": "Streaming Dashboard",
  "AppDashboard": "App Dashboard",
  "AppTemplates": "App Templates",
  "UserAdmin": "User Admin",
  "UserGroups": "User Groups",
  "UserRoles": "User Roles",
  "UserManagement": "User Management",
  "UserRegistration": "User Registration",
  "WebConsole": "Web Console",
  "APIControl": "API Control",
  "APIPlayground": "API Playground",
  "SSLControl": "SSL Control",
  "VPNControl": "VPN Control",
  "Changelog": "Changelog",
  "News": "News",
  "SystemLogs": "System Logs",
  "AuditLog": "Audit Log",
  "AssetManagementCenter": "Asset Management Center",
  "Account": "Account",
  "Activation": "Activation",
  "ActivityLogs": "Activity Logs",
  "AdditionalDashboardSettings": "Additional dashboard settings",
  "Advanced": "Advanced",
  "AllNotifications": "All notifications",
  "ApplicationBackups": "Application Backups",
  "ApplicationLogos": "Application Logos",
  "AuthPages": "Auth pages",
  "AutomationTools": "Automation & Tools",
  "Avatars": "Avatars",
  "BrandAssets": "Brand Assets",
  "Branding": "Branding",
  "CPUMemory": "CPU & Memory",
  "ChannelSetup": "Channel setup",
  "Channels": "Channels",
  "CommandChannel": "Command Channel",
  "CommandAliases": "Command aliases",
  "Communication": "Communication",
  "Compose": "Compose",
  "Concurrency": "Concurrency",
  "Content": "Content",
  "ControlCenter": "Control Center",
  "DBManagement": "DB Management",
  "DefaultGroup": "Default Group",
  "DeleteProtection": "Delete Protection",
  "Devices": "Devices",
  "Diagnostics": "Diagnostics",
  "DiskUsageAlerts": "Disk usage alerts",
  "DisplayPreferences": "Display preferences",
  "Documentation": "Documentation",
  "DownloadClients": "Download Clients",
  "EBooksComics": "E-Books & Comics",
  "EnableConsent": "Enable & consent",
  "EnableSupportAccess": "Enable support access",
  "Fail2BanProtection": "Fail2Ban Protection",
  "FeatureFlags": "Feature flags",
  "FileManagement": "File Management",
  "FirewallRules": "Firewall Rules",
  "GeoBlock": "Geo-Block",
  "GeoLock": "Geo-Lock",
  "HardwareHealth": "Hardware Health",
  "History": "History",
  "HistoryAnalytics": "History & Analytics",
  "IndexersTrackers": "Indexers & Trackers",
  "InstanceSettings": "Instance settings",
  "InterInstanceTransfer": "Inter-Instance Transfer",
  "InterInstanceTransfers": "Inter-Instance Transfers",
  "LinkedChannels": "Linked channels",
  "LocalAssets": "Local Assets",
  "Log": "Log",
  "MediaManagement": "Media Management",
  "MediaPortal": "Media Portal",
  "MediaRequests": "Media Requests",
  "TvGuide": "TV Guide",
  "MediaServers": "Media Servers",
  "Network": "Network",
  "NotificationEvents": "Notification events",
  "Overview": "Overview",
  "Passkeys": "Passkeys",
  "PasswordPolicy": "Password Policy",
  "PersistenceCookies": "Persistence & Cookies",
  "ProfilePicture": "Profile picture",
  "Provider": "Provider",
  "QuickLinks": "Quick links",
  "Quotas": "Quotas",
  "RemoteAccess": "Remote Access",
  "RestrictedShell": "Restricted Shell",
  "Security": "Security",
  "ServerUsers": "Server Users",
  "ServiceHealth": "Service Health",
  "SessionOperations": "Session Operations",
  "Sessions": "Sessions",
  "SessionsSecurity": "Sessions & security",
  "SoftwareRAID": "Software RAID",
  "StreamingMaintenance": "Streaming Maintenance",
  "SystemInventory": "System Inventory",
  "SystemMetrics": "System metrics",
  "TelemetryHistory": "Telemetry History",
  "Templates": "Templates",
  "Timeouts": "Timeouts",
  "TimezoneLocale": "Timezone & locale",
  "Transfer": "Transfer",
  "TwoFactorAuth": "Two-factor auth",
  "UpdatesAvailable": "Updates Available",
  "UpdatesDigest": "Updates digest",
  "Uploads": "Uploads",
  "UsernamePolicy": "Username Policy",
  "Users": "Users",
  "UtilitiesSystem": "Utilities & System",
  "WatchAnalytics": "Watch Analytics",
  "WelcomeEmail": "Welcome Email"
} as const;
